import React, { useState, useEffect } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Home, 
  // Users, 
  // Settings, 
  LogOut,
  // Upload,
  Menu,
  X
} from 'lucide-react';
import Notification from '../../components/Notification/Notification';
import './AdminLayout.css';

const AdminLayout = () => {
  const [notification, setNotification] = useState({
    show: false,
    message: '',
    type: ''
  });
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();

  // Check if screen is mobile size
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setMobileSidebarOpen(false);
      }
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Close mobile sidebar when route changes
  useEffect(() => {
    if (isMobile) {
      setMobileSidebarOpen(false);
    }
  }, [location.pathname, isMobile]);

  const showNotification = (message, type = 'error') => {
    setNotification({
      show: true,
      message,
      type
    });
    
    setTimeout(() => {
      setNotification(prev => ({ ...prev, show: false }));
    }, 5000);
  };

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminName');
    showNotification('Logged out successfully', 'success');
    window.location.href = '/admin/login';
  };

  const handleMobileSidebarToggle = () => {
    setMobileSidebarOpen(!mobileSidebarOpen);
  };

  const handleOverlayClick = () => {
    setMobileSidebarOpen(false);
  };

  const navItems = [
    { path: '/admin/dashboard', icon: <LayoutDashboard size={20} />, label: 'Dashboard' },
    { path: '/admin/manage-projects', icon: <Home size={20} />, label: 'Projects' },
    // { path: '/admin/heroimage-upload', icon: <Upload size={20} />, label: 'Hero Image' },
    // { path: '/admin/users', icon: <Users size={20} />, label: 'Users' },
    // { path: '/admin/settings', icon: <Settings size={20} />, label: 'Settings' }
  ];

  return (
    <div className="admin-layout">
      <Notification 
        show={notification.show} 
        message={notification.message} 
        type={notification.type}
        onClose={() => setNotification(prev => ({ ...prev, show: false }))}
      />

      {/* Mobile sidebar overlay */}
      {isMobile && (
        <div 
          className={`sidebar-overlay ${mobileSidebarOpen ? 'show' : ''}`}
          onClick={handleOverlayClick}
        />
      )}

      {/* Mobile sidebar toggle button */}
      <button 
        className="mobile-sidebar-toggle"
        onClick={handleMobileSidebarToggle}
        aria-label="Toggle sidebar"
      >
        {mobileSidebarOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Sidebar */}
      <aside className={`admin-sidebar ${!isMobile && sidebarOpen ? 'open' : !isMobile ? 'closed' : ''} ${mobileSidebarOpen ? 'mobile-open' : ''}`}>
        <div className="sidebar-header">
          <h2>Admin Panel</h2>
          {!isMobile && (
            <button 
              className="sidebar-toggle"
              onClick={() => setSidebarOpen(!sidebarOpen)}
              aria-label="Toggle sidebar"
            >
              {sidebarOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
          )}
        </div>

        <nav className="sidebar-nav">
          <ul>
            {navItems.map((item) => (
              <li key={item.path}>
                <Link 
                  to={item.path} 
                  className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
                  onClick={() => isMobile && setMobileSidebarOpen(false)}
                >
                  <span className="nav-icon">{item.icon}</span>
                  {(sidebarOpen || isMobile) && <span className="nav-label">{item.label}</span>}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="sidebar-footer">
          <button 
            className="logout-btn"
            onClick={handleLogout}
          >
            <LogOut size={20} />
            {(sidebarOpen || isMobile) && <span>Logout</span>}
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="admin-main">
        <div className="admin-header">
          <h1>
            {navItems.find(item => item.path === location.pathname)?.label || 'Dashboard'}
          </h1>
          <div className="admin-profile">
            <span>Welcome, {localStorage.getItem('adminName') || 'Admin'}</span>
            <img 
              src="https://res.cloudinary.com/dggey8rb6/image/upload/f_auto,q_auto/v1747041341/user_nrxm0a.jpg" 
              alt="User profile"
              className='user-img' 
            />
          </div>
        </div>
        
        <div className="admin-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;